import { UrlParamKeys } from '../../app/UrlParamKeys';
import { FlowContentType } from '../models/ContentTypes';
import { FlowDetailInfo } from '../models/FlowInfo';
import { Module } from '../Module';
import { DefaultStateFor } from '../services/ContentUrl';
import { PublishFlowAction } from '../services/PublishFlowAction';

export class FlowPublishResultCtrl {

  public static $inject = [
    'flowDetailInfo',
    'FlowPublishResultService',
  ];

  constructor(
    flowDetailInfo: FlowDetailInfo,
    flowPublishResultService: FlowPublishResultService,
  ) {
    flowPublishResultService.handlePublishedFlow(flowDetailInfo);
  }
}

Module.instance().controller('FlowPublishResultCtrl', FlowPublishResultCtrl);

export class FlowPublishResultService {

  public static $inject = [
    '$location',
    '$state',
    '$rootScope',
    'PublishFlowAction',
  ];

  constructor(
    private $location: ng.ILocationService,
    private $state: ng.ui.IStateService,
    private $rootScope: ng.IRootScopeService,
    private PublishFlowAction: PublishFlowAction,
  ) {
  }

  public handlePublishedFlow(flowDetailInfo: FlowDetailInfo) {
    const search = this.$location.search();

    const publishedDatasourcesStr: string = search[UrlParamKeys.PublishedDataSources];
    const publishedDatasourceUrlNames: string[] = publishedDatasourcesStr ? publishedDatasourcesStr.split(',') : [];

    // If we open the modal now and then initiate a state change, the modal will not open properly.
    // So, we'll wait for the state to finish changing and then open the modal
    const removeEvent = this.$rootScope.$on('$locationChangeSuccess',
      () => {
        removeEvent();
        this.PublishFlowAction.handlePublishedFlow(flowDetailInfo, publishedDatasourceUrlNames);
      }
    );

    this.$state.go(DefaultStateFor(FlowContentType.name));
  }
}

Module.instance().service('FlowPublishResultService', FlowPublishResultService);
